export default "__VITE_ASSET__59e556b1__"